import { CheckIcon, MinusIcon } from 'lucide-react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';

import { type ComponentProps, type FC } from 'react';
import { cn } from '../lib/utils';

export const Checkbox: FC<ComponentProps<typeof CheckboxPrimitive.Root>> = ({
  className,
  ...props
}) => {
  return (
    <CheckboxPrimitive.Root
      type="button"
      data-slot="checkbox"
      className={cn(
        'shadow-xs peer size-5 shrink-0 rounded-sm border border-border-strong outline-none transition-shadow focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=indeterminate]:border-primary data-[state=checked]:bg-primary data-[state=indeterminate]:bg-primary data-[state=checked]:text-text-inverse data-[state=indeterminate]:text-text-inverse aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        {props.checked === 'indeterminate' ? (
          <MinusIcon className="size-3.5" />
        ) : (
          <CheckIcon className="size-3.5" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};
